export const SettingsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.885 12.005c0 2.27 1.85 4.12 4.12 4.12s4.12-1.85 4.12-4.12-1.85-4.12-4.12-4.12-4.12 1.85-4.12 4.12m1.24 0a2.88 2.88 0 1 1 5.761.001 2.88 2.88 0 0 1-5.761-.001"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.595 21.775c.1.22.33.35.56.35l-.01.01c.07 0 .14-.01.2-.03 1.45-.48 2.77-1.26 3.9-2.32.23-.21.27-.55.1-.8-.6-.92-.64-2.07-.09-3.01a2.91 2.91 0 0 1 2.5-1.43h.06c.3-.02.57-.21.63-.51.29-1.5.25-3.02-.12-4.51a.62.62 0 0 0-.6-.48 2.85 2.85 0 0 1-2.46-1.43c-.49-.84-.52-1.87-.07-2.74.13-.25.07-.56-.14-.75a10.5 10.5 0 0 0-3.95-2.22.616.616 0 0 0-.7.25c-.54.8-1.43 1.28-2.4 1.28s-1.86-.48-2.4-1.28a.62.62 0 0 0-.7-.25c-1.46.44-2.79 1.19-3.95 2.22-.21.19-.27.5-.14.75a2.866 2.866 0 0 1-2.53 4.17.63.63 0 0 0-.6.48 10.6 10.6 0 0 0-.12 4.51c.06.3.33.51.63.51 1.07-.06 2.03.52 2.55 1.43.55.94.51 2.09-.09 3-.16.25-.12.59.1.8 1.13 1.06 2.44 1.84 3.9 2.32.3.1.62-.04.76-.32a2.85 2.85 0 0 1 2.59-1.63c1.11 0 2.1.63 2.59 1.63m.85-1.04a4.09 4.09 0 0 0-3.44-1.84c-1.38 0-2.67.71-3.43 1.84-.95-.37-1.82-.89-2.6-1.55.59-1.22.55-2.64-.14-3.84a4.15 4.15 0 0 0-3.12-2.03c-.14-1.02-.11-2.05.09-3.06 1.25-.17 2.38-.92 3.02-2.02.62-1.06.72-2.33.3-3.47q1.245-1.005 2.73-1.53a4.14 4.14 0 0 0 3.15 1.45c1.23 0 2.37-.53 3.15-1.45.98.35 1.9.86 2.73 1.53-.42 1.14-.32 2.4.3 3.47a4.12 4.12 0 0 0 3.02 2.02q.3 1.53.09 3.06c-1.29.14-2.45.89-3.11 2.03a4.08 4.08 0 0 0-.14 3.84c-.79.66-1.66 1.18-2.6 1.55"
      clipRule="evenodd"
    ></path>
  </svg>
);
